export const buildView = () => {
  const circuloSuperior = document.querySelector('.semiCirculo') as HTMLDivElement

  if (!circuloSuperior) return

  let width = circuloSuperior.clientWidth
  let higth = circuloSuperior.clientHeight
  let half = width * 0.5
  let preEnd = higth

  window.addEventListener('resize', () => {
    width = circuloSuperior.clientWidth
    higth = circuloSuperior.clientHeight
    half = width * 0.5

    if (window.innerWidth < 500) {
      preEnd = higth * 0.92
    } else if (window.innerWidth < 1000) {
      preEnd = higth * 0.82
    } else if (window.innerWidth < 1500) {
      preEnd = higth * 0.72
    } else {
      preEnd = higth * 0.62
    }

    circuloSuperior.style.clipPath = `path("M 0,0 L ${0},${preEnd} A ${width*0.9},${width*0.55} 0,0,0 ${half},${higth} A ${width*0.9},${width*0.55} 0,0,0 ${width},${preEnd} L ${width},0 Z")`
  })

  if (window.innerWidth < 500) {
    preEnd = higth * 0.92
  } else if (window.innerWidth < 800) {
    preEnd = higth * 0.82
  } else if (window.innerWidth < 1200) {
    preEnd = higth * 0.72
  } else {
    preEnd = higth * 0.62
  }

  circuloSuperior.style.clipPath = `path("M 0,0 L ${0},${preEnd} A ${width*0.9},${width*0.55} 0,0,0 ${half},${higth} A ${width*0.9},${width*0.55} 0,0,0 ${width},${preEnd} L ${width},0 Z")`
}

export const showHideWaitMedic = (value: boolean) => {
  const container = document.querySelector('.container') as HTMLDivElement

  if (value) container.classList.add('show')
  else {
    container.classList.add('hide')

    setTimeout(() => {
      container.style.display = "none"
    }, 1000)
  }
}